import type { User } from "firebase/auth";

// POC-grade gating for the /feedback backoffice: an allowlist of Firebase Auth
// UIDs from VITE_ADMIN_UIDS (comma-separated). This is a stopgap until proper
// custom-claim roles land with the full review queue — it keeps the raw feedback
// dump away from pilot users without standing up claim plumbing yet.
function adminUids(): string[] {
  return (import.meta.env.VITE_ADMIN_UIDS ?? "")
    .split(",")
    .map((uid) => uid.trim())
    .filter(Boolean);
}

export function isAdmin(user: User | null | undefined): boolean {
  return !!user && adminUids().includes(user.uid);
}
